import Vue from 'vue'
import ViewUI from 'view-design'
import locale from 'view-design/dist/locale/en-US'

Vue.use(ViewUI, { locale })

import 'view-design/dist/styles/iview.css'
